import script from "./fee.vue?vue&type=script&lang=ts&setup=true"
export * from "./fee.vue?vue&type=script&lang=ts&setup=true"

import "./fee.vue?vue&type=style&index=0&id=3479c6c2&lang=scss"

const __exports__ = script;

export default __exports__